<template>
  <div>
    <vue-form-generator ref="projectForm" :schema="schema" :model="model" :options="formOptions"> </vue-form-generator>
    <b-button v-if="load && load.id" href="#" variant="success" @click="update()">Сохранить</b-button>
    <b-button v-else href="#" variant="success" @click="create()">Создать</b-button>
  </div>
</template>
<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
export default {
  name: "newProject",
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  props: {
    load: Object,
    project: Object,
    room: Object,
    cell: Object,
    isNewRecord: Boolean,
    substances: Array,
  },

  watch: {
    substances() {
      this.schema.groups[0].fields[0].values = this.substances;
    },
    room: function () {
      Object.assign(this.model, this.load);
    },
  },
  data() {
    return {
      model: {
        substance: 0,
        substance0: {},
        mass: 0,
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "vueMultiSelect",
                label: "Содержимое вещество",
                model: "substance0",
                required: true,
                values: [],
                placeholder: "Выберите вещество",
                selectOptions: {
                  selectLabel: "Нажмите enter",
                  selectedLabel: "Выбрано",
                  deselectLabel: "Нажмите enter",
                  multiple: false,
                  trackBy: "id",
                  key: "id",
                  label: "name",
                  searchable: true,
                  closeOnSelect: true,
                  allowEmpty: false,
                  groupValues: "subs",
                  groupLabel: "type",
                  optionsLimit: 2000,
                },
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Масса, кг",
                model: "mass",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  methods: {
    create() {
      var data = this.model;
      data.substance = data.substance0.id;
      this.$http
        .post("category/cells/load-add?room_id=" + this.room.id + "&cell_id=" + this.cell.id, data)
        .then((response) => {
          if (!this.room.cells[this.cell.index].loads) {
            this.$set(this.room.cells[this.cell.index], "loads", []);
          }
          this.room.cells[this.cell.index].loads.push(response.data);
          this.$emit("hideWindow");
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
    update() {
      var data = this.model;
      data.substance = data.substance0.id;
      this.$http
        .post(
          "category/cells/load-update?room_id=" + this.room.id + "&cell_id=" + this.cell.id + "&load_id=" + data.id,
          data
        )
        .then((response) => {
          var newData = response.data;
          newData.substance0 = data.substance0;
          this.$emit("update:load", Object.assign(this.load, newData));
          this.$emit("hideWindow");
        })
        .catch((e) => {
          if (e.response.data) {
            this.$set(this.model, "validator", e.response.data);
            this.$refs.projectForm.validate();
          }
        });
    },
  },

  mounted() {
    this.schema.groups[0].fields[0].values = this.substances;
    if (this.load) {
      Object.assign(this.model, this.load);
    }
  },
};
</script>
